
export const publicRoutesPath = {
    LOGIN: "/",
    SIGNUP: "/signup",
    FORGOTPASSWORD: "/forgot-password",
    FIRST_USER_PASSWORD_SETUP: "/set-user-password"
}

export const privateRoutesPath = {
    REPORTS: '/biztantu/reports',
    BIZTANTU: '/biztantu',
    DASHBOARD: '/biztantu/dashboard',
    LEADS: '/biztantu/leads',
    CUSTOMER: '/biztantu/customer',
    MERCHANT: '/biztantu/merchant',
    PRODUCT: '/biztantu/product',
    CONFIGURATION: '/biztantu/configuration',
    CREATE_LEAD: '/biztantu/leads/create-lead',
    EDIT_LEAD: `/biztantu/leads/edit-lead`,
    COMMON_BULK_UPLOAD: '/biztantu/common/bulk-upload',

    CREATE_PRODUCT: '/biztantu/product/create-product',
    PRODUCT_BULK_UPLOAD: '/biztantu/product/bulk-upload',
    EDIT_PRODUCT: `/biztantu/product/edit-product`,

    CREATE_MERCHANT: '/biztantu/merchant/create-merchant',
    EDIT_MERCHANT: `/biztantu/merchant/edit-merchant`,
    MERCHANT_BULK_UPLOAD: '/biztantu/merchant/bulk-upload',

    CREATE_CUSTOMER: '/biztantu/customer/create-customer',
    EDIT_CUSTOMER: `/biztantu/customer/edit-customer`,
    CUSTOMER_BULK_UPLOAD: '/biztantu/customer/bulk-upload',

    INVOICE: '/biztantu/invoice',
    CREATE_INVOICE:`/biztantu/invoice/create-invoice`,
    EDIT_INVOICE: '/biztantu/invoice/edit-invoice',

    ORDER: '/biztantu/order',
    VIEW_ORDER: '/biztantu/order/edit-order',
    CREATE_ORDER: '/biztantu/order/create-order',
    
    TASKS: '/biztantu/tasks',
    TELECALLING: '/biztantu/workflow/telecalling',
    DIALER: '/biztantu/dialer',
    TASKS_CREATE: '/biztantu/tasks/create-tasks',
    EDIT_TASK: '/biztantu/tasks/edit-task',

    LEAD_BULK_UPLOAD_MAPPING: '/biztantu/leads/bulk-upload/mapping',
    GLOBAL_SEARCH: '/biztantu/global-search',
    BIZTANTU_CAMPAIGN: "/biztantu/campaign",
    CREATE_CAMPAIGN: "/biztantu/campaign/create-campaign",
    EDIT_CAMPAIGN: "/biztantu/campaign/edit-campaign",
    REQUEST_CAMPAIGN: "/biztantu/request-campaign",

    CREATE_TEMPLATE: "/biztantu/template/create-template",
    BIZTANTU_TEMPLATE: "/biztantu/template",
    EDIT_TEMPLATE: "/biztantu/template/edit-template",
    SEND_EXTERNAL_EMAIL: "/biztantu/campaign/send-external-email",

    BIZTANTU_AUDIT: "/biztantu/audit",
    PROFILE: "/biztantu/profile",

    WORKFLOW : "/biztantu/workflow",
    CREATE_WORKFLOW : "/biztantu/workflow/create-workflow",

    UNAUTHORIZED: "/biztantu/unauthorized",
    PAGE_NOT_FOUND: "/biztantu/page-not-found",
} 

/**
 * Maps every private route path pattern to the rolebasedData permission key
 * required to access it. A value of null means accessible to all authenticated users.
 * Used by RequirePermission to enforce route-level RBAC.
 */
export const routePermissionMap = {
    [privateRoutesPath.DASHBOARD]:          'isDashboradView',
    [privateRoutesPath.LEADS]:              'isLeadView',
    [privateRoutesPath.CREATE_LEAD]:        'isLeadManage',
    [privateRoutesPath.EDIT_LEAD]:          'isLeadManage',
    [privateRoutesPath.CUSTOMER]:           'isCustomerView',
    [privateRoutesPath.CREATE_CUSTOMER]:    'isCustomerManage',
    [privateRoutesPath.EDIT_CUSTOMER]:      'isCustomerManage',
    [privateRoutesPath.MERCHANT]:           'isVendorView',
    [privateRoutesPath.CREATE_MERCHANT]:    'isVendorManage',
    [privateRoutesPath.EDIT_MERCHANT]:      'isVendorManage',
    [privateRoutesPath.PRODUCT]:            'isProductView',
    [privateRoutesPath.CREATE_PRODUCT]:     'isProductManage',
    [privateRoutesPath.EDIT_PRODUCT]:       'isProductManage',
    [privateRoutesPath.INVOICE]:            'isInvoiceView',
    [privateRoutesPath.CREATE_INVOICE]:     'isInvoiceManage',
    [privateRoutesPath.EDIT_INVOICE]:       'isInvoiceManage',
    [privateRoutesPath.ORDER]:              'isOrderView',
    [privateRoutesPath.CREATE_ORDER]:       'isOrderManage',
    [privateRoutesPath.VIEW_ORDER]:         'isOrderManage',
    [privateRoutesPath.TASKS]:              'isTaskView',
    [privateRoutesPath.TASKS_CREATE]:       'isTaskManage',
    [privateRoutesPath.EDIT_TASK]:          'isTaskManage',
    [privateRoutesPath.CONFIGURATION]:      'isConfigurationView',
    [privateRoutesPath.REPORTS]:            'isReportView',
    [privateRoutesPath.BIZTANTU_AUDIT]:     'isAuditView',
    [privateRoutesPath.BIZTANTU_TEMPLATE]:  'isNotificationView',
    [privateRoutesPath.CREATE_TEMPLATE]:    'isTemplateManage',
    [privateRoutesPath.EDIT_TEMPLATE]:      'isTemplateManage',
    [privateRoutesPath.BIZTANTU_CAMPAIGN]:  'isNotificationView',
    [privateRoutesPath.REQUEST_CAMPAIGN]:   'isNotificationManage',
    [privateRoutesPath.SEND_EXTERNAL_EMAIL]:'isNotificationManage',
    [privateRoutesPath.WORKFLOW]:           'isWorkflowView',
    [privateRoutesPath.CREATE_WORKFLOW]:    'isWorkflowManage',
    [privateRoutesPath.COMMON_BULK_UPLOAD]: 'isLeadManage',
    // Accessible to all authenticated users — no specific permission required
    [privateRoutesPath.GLOBAL_SEARCH]:      null,
    [privateRoutesPath.PROFILE]:            null,
}